import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {isEmpty} from 'lodash/lang';
import moment from 'moment';
import * as fields from 'components/common/fields';
import {AutoSuggestSelect, SubscriptionUserFields} from 'components/common';
import * as validators from 'utils/validators';
import {makeForm, getDefaultSubscriptionExpiryDate, formatDatetime, momentDatetime} from 'utils/common';
import {fetchSchools, fetchClassrooms, fetchOrders} from 'api';
import * as permission from 'utils/permissions';

class SubscriptionForm extends React.Component {
  constructor(props) {
    super(props);
    this.fetchSchools = this.fetchSchools.bind(this);
    this.fetchClassrooms = this.fetchClassrooms.bind(this);
    this.fetchOrders = this.fetchOrders.bind(this);
    this.handleSchoolChange = this.handleSchoolChange.bind(this);
    this.dateToday = moment();
  }

  fetchSchools(value) {
    return fetchSchools(value).then(({records}) => records);
  }

  fetchClassrooms(schoolId, value) {
    return fetchClassrooms(value, undefined, undefined, undefined, {schoolId}).then(({records}) => records);
  }

  fetchOrders(schoolId) {
    return fetchOrders(undefined, undefined, undefined, undefined, {schoolId, activeOnly: true}).then(({records}) =>
      records.map((record) => ({
        ...record,
        name: `${record.name} (Order expires at: ${formatDatetime(record.expiryDate, false, 'MMMM Do, YYYY')})`,
      })),
    );
  }

  handleSchoolChange() {
    this.props.clearFields(false, false, 'classroom');
    this.props.clearFields(false, false, 'order');
  }

  render() {
    const {
      isUpdate,
      noEmail,
      activated,
      role,
      schoolId,
      classroomId,
      school,
      order,
      handleSubmit,
      pristine,
      submitting,
    } = this.props;
    const selectedSchoolId = schoolId ? schoolId : !isEmpty(school) && school.id;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          {activated ? (
            <Col md={6}>
              <Field
                name="expiryDate"
                label="Expiry Date"
                minDate={this.dateToday}
                component={fields.DatePicker}
                required
                validate={[validators.isRequired]}
                readOnly={!permission.isKluwellAdmin(role)}
                maxDate={isEmpty(order) ? undefined : momentDatetime(order.expiryDate)}
              />
            </Col>
          ) : (
            <React.Fragment>
              {!isUpdate && noEmail ? (
                <SubscriptionUserFields />
              ) : (
                <Col md={6}>
                  <Field
                    name="email"
                    label="E-mail Address"
                    component={fields.Input}
                    required
                    validate={isUpdate ? undefined : [validators.isRequired, validators.isEmail]}
                    disabled={isUpdate}
                  />
                </Col>
              )}
              {!schoolId && !classroomId && (
                <Col md={6}>
                  <AutoSuggestSelect
                    name="school"
                    label="School"
                    labelKey="name"
                    valueKey="id"
                    onSearch={this.fetchSchools}
                    onChange={this.handleSchoolChange}
                    required
                    validate={[validators.isRequired]}
                  />
                </Col>
              )}
              {selectedSchoolId && (
                <Col md={schoolId ? 12 : 6}>
                  <AutoSuggestSelect
                    key={selectedSchoolId}
                    name="order"
                    label="Order"
                    labelKey="name"
                    valueKey="id"
                    onSearch={(...args) => this.fetchOrders(selectedSchoolId, ...args)}
                    required
                    validate={[validators.isRequired]}
                  />
                </Col>
              )}
              {!classroomId && selectedSchoolId && (
                <Col md={schoolId ? 12 : 6}>
                  <AutoSuggestSelect
                    key={selectedSchoolId}
                    name="classroom"
                    label="Classroom"
                    labelKey="name"
                    valueKey="id"
                    onSearch={(...args) => this.fetchClassrooms(selectedSchoolId, ...args)}
                    required
                    validate={[validators.isRequired]}
                  />
                </Col>
              )}
            </React.Fragment>
          )}
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = {
  Creation: (state) => ({
    role: state.account.getIn(['user', 'role']),
    initialValues: {
      expiryDate: getDefaultSubscriptionExpiryDate(),
    },
  }),
  Update: (state, ownProps) => {
    const {subscription} = ownProps;
    const {reader, school, classroom, order} = subscription;
    return {
      role: state.account.getIn(['user', 'role']),
      activated: subscription.status === 'activated',
      isUpdate: true,
      order,
      initialValues: {
        email: reader.email,
        expiryDate: subscription.expiryDate,
        school: {id: school.id, name: school.name},
        classroom: {id: classroom.id, name: classroom.name},
      },
    };
  },
};

export default {
  Creation: makeForm(SubscriptionForm, 'SubscriptionForm.Creation', mapStateToProps.Creation, null, ['school']),
  Update: makeForm(SubscriptionForm, 'SubscriptionForm.Update', mapStateToProps.Update, null, ['school']),
};
